(function () {
  // Reconcile stored item payouts to the authoritative line net; never calculate payroll here.
  const money = (value) => Math.round(Number(value || 0) * 100) / 100;
  const itemPayout = (item) => {
    if (item.payType === 'holiday-deduction') return money(Number(item.grossSalary || 0) - Number(item.taxDeduction || 0));
    if (item.payTypeSnapshot?.kind === 'Trekk' && item.payType !== 'pension-premium') return -money(Number(item.deductionAmount || 0) + Number(item.taxDeduction || 0));
    return item.payoutAmount == null ? null : money(item.payoutAmount);
  };
  const forLine = (line) => {
    const items = Array.isArray(line.items) ? line.items : [];
    const netPay = money(line.netPay);
    const adjustments = [];
    const complete = items.length > 0 && items.every((item) => Number.isFinite(Number(item.payoutAmount)) && item.payoutAmount != null);
    if (complete) {
      const itemNet = money(items.reduce((sum, item) => sum + Number(itemPayout(item)), 0));
      const nonCashTax = money(items.filter((item) => item.payTypeSnapshot?.kind === 'Naturalytelse').reduce((sum, item) => sum + Number(item.taxDeduction || 0), 0));
      if (nonCashTax) adjustments.push({ key: 'pay.taxOnNonCashBenefits', amount: -nonCashTax });
      const remainder = money(netPay - itemNet + nonCashTax);
      if (remainder) adjustments.push({ key: 'pay.netReconciliation', amount: remainder });
    }
    return { netPay, adjustments, complete };
  };
  window.PlummePayrollPayoutPresentation = { forLine, itemPayout };
})();
